import { Expose, Type } from "class-transformer";
import { IsArray, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class IntegrationListItem {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  providerName!: string;
  @Expose()
  @IsString()
  providerType!: string;
}

export class IntegrationListItemResponse extends GenericTableResponse<IntegrationListItem> {
  @Expose()
  @IsArray()
  @Type(() => IntegrationListItem)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<IntegrationListItem>;
}
